<template>
  <el-tag
    class="base-tag"
    :type="type"
    :size="size"
    :effect="effect"
    :round="round"
    :closable="closable"
    :disable-transitions="disableTransitions"
    @close="$emit('close', $event)"
    @click="$emit('click', $event)"
  >
    <slot />
  </el-tag>
</template>

<script setup>
defineProps({
  type: {
    type: String,
    default: 'info'
  },
  size: {
    type: String,
    default: 'default'
  },
  effect: {
    type: String,
    default: 'light'
  },
  round: {
    type: Boolean,
    default: false
  },
  closable: {
    type: Boolean,
    default: false
  },
  disableTransitions: {
    type: Boolean,
    default: false
  }
})

defineEmits(['close', 'click'])
</script>

<style scoped lang="scss">
.base-tag {
  max-width: 100%;
}
</style>
